module.exports = __webpack_public_path__ + "static/background-mobile-c318ea3be2bd17cfb270ac97ea55f230.jpg";